
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
// import Button from '../../../common/button/Button';
import FirebaseAuth from '../containers/FirebaseAuthContainer';
import { showError } from '../../../common/A1Alert/A1Alert';
import ShowPassword from '../../../common/showPassword/ShowPassword';


function validate(name, email, confirmEmail, password, confirmPassword) {
    const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const nameRegex = /^[a-z\u00C0-\u017F\s ]+$/i;
    const nameValid = name.match(nameRegex) != null && name.length >= 3 && name.length <= 50;
    const emailValid = email.match(emailRegex) != null && email.length <= 50;
    const confirmEmailValid = (confirmEmail === email);
    const passwordValid = password.length >= 6 && password.length <= 20;
    const confirmPasswordValid = (confirmPassword === password);

    return {
        name: !nameValid,
        email: !emailValid,
        confirmEmail: !confirmEmailValid,
        password: !passwordValid,
        confirmPassword: !confirmPasswordValid,
    };
}

class Register extends Component {
    constructor(props) {
        super(props);

        this.state = {
            name: '',
            email: '',
            confirmEmail: '',
            password: '',
            confirmPassword: '',
            touched: {
                name: false,
                email: false,
                confirmEmail: false,
                password: false,
                confirmPassword: false,
            },
        };
    }

    handleNameChange = (evt) => {
        const tempTouched = this.state.touched;

        this.setState({
            name: evt.target.value,
            touched: { ...tempTouched, name: true },
        });
    }

    handleEmailChange = (evt) => {
        const tempTouched = this.state.touched;

        this.setState({
            email: evt.target.value,
            touched: { ...tempTouched, email: true },
        });
    }

    handleConfirmEmailChange = (evt) => {
        const tempTouched = this.state.touched;

        this.setState({
            confirmEmail: evt.target.value,
            touched: { ...tempTouched, confirmEmail: true },
        });
    }

    handlePasswordChange = (evt) => {
        const tempTouched = this.state.touched;

        this.setState({
            password: evt.target.value,
            touched: { ...tempTouched, password: true },
        });
    }

    handleConfirmPasswordChange = (evt) => {
        const tempTouched = this.state.touched;

        this.setState({
            confirmPassword: evt.target.value,
            touched: { ...tempTouched, confirmPassword: true },
        });
    }

    handleSubmit = (evt) => {
        evt.preventDefault();

        if (this.props.firebasePopupOpen) {
            // This can only happen if the user filled the form and afterwards clicks on a social login and then clicks the submit button
            return showError('A autenticação já foi iniciada. Por favor, finalize o processo na outra janela.');
        }

        if (!this.canBeSubmitted()) {
            return false;
        }

        const data = {
            name: this.state.name,
            email: this.state.email,
            password: this.state.password,
        };

        return this.props.registerUser(data);
    }

    canBeSubmitted() {
        const erros = validate(
            this.state.name,
            this.state.email,
            this.state.confirmEmail,
            this.state.password,
            this.state.confirmPassword,
        );
        const disabled = Object.keys(erros).some((x) => erros[x]);

        return !disabled;
    }

    render() {
        const erros = validate(
            this.state.name,
            this.state.email,
            this.state.confirmEmail,
            this.state.password,
            this.state.confirmPassword,
        );
        const disabled = Object.keys(erros).some((x) => erros[x]) || !!this.props.submitting;
        let nameRed = this.state.touched.name;
        let emailRed = this.state.touched.email;
        let confirmEmailRed = this.state.touched.confirmEmail;
        let passwordRed = this.state.touched.password;
        let confirmPasswordRed = this.state.touched.confirmPassword;

        if (nameRed) {
            nameRed = erros.name;
        }

        if (emailRed) {
            emailRed = erros.email;
        }

        if (confirmEmailRed) {
            confirmEmailRed = erros.confirmEmail;
        }

        if (passwordRed) {
            passwordRed = erros.password;
        }

        if (confirmPasswordRed) {
            confirmPasswordRed = erros.confirmPassword;
        }

        return (
            <section className="sectionRegister">
                <header>
                    <h2>
                        Faça seu cadastro
                        <br />
                        e acesse o site.
                    </h2>
                    <h3>Você poderá participar de nossas promoções, sorteios e muito mais!</h3>
                </header>
                <form className="registerForm" onSubmit={this.handleSubmit}>

                    <div className="modal-input">
                        <label htmlFor="registerName">
                            Nome completo
                            <sup>*</sup>
                        </label>
                        <input
                            className={nameRed ? 'error' : ''}
                            name="registerName"
                            type="text"
                            id="registerName"
                            value={this.state.name}
                            onChange={this.handleNameChange}
                            required
                            autoComplete="name"
                            autoCapitalize="words"
                        />
                    </div>

                    <div className="modal-input">
                        <label htmlFor="registerEmail">
                            E-mail
                            <sup>*</sup>
                        </label>
                        <input
                            className={emailRed ? 'error' : ''}
                            type="email"
                            name="registerEmail"
                            id="registerEmail"
                            value={this.state.email}
                            onChange={this.handleEmailChange}
                            required
                            autoComplete="email"
                            autoCapitalize="off"
                            autoCorrect="off"
                        />
                    </div>

                    <div className="modal-input">
                        <label htmlFor="registerConfirmEmail">
                            Confirme seu e-mail
                            <sup>*</sup>
                        </label>
                        <input
                            className={confirmEmailRed ? 'error' : ''}
                            type="email"
                            id="registerConfirmEmail"
                            value={this.state.confirmEmail}
                            onChange={this.handleConfirmEmailChange}
                            required
                            autoComplete="off"
                            autoCapitalize="off"
                            autoCorrect="off"
                        />
                    </div>

                    <div className="modal-input">
                        <ShowPassword
                            className={passwordRed ? 'error' : ''}
                            label="Senha *"
                            name="registerPassword"
                            id="registerPassword"
                            value={this.state.password}
                            onChange={this.handlePasswordChange}
                            required
                        />
                    </div>
                    <div className="modal-input">
                        <ShowPassword
                            className={confirmPasswordRed ? 'error' : ''}
                            name="registerConfirmPassword"
                            id="registerConfirmPassword"
                            value={this.state.confirmPassword}
                            onChange={this.handleConfirmPasswordChange}
                            required
                            label="Confirme sua senha *"
                        />
                    </div>

                    <div className="containerTerms tw-mt-4">
                        <p>
                            Sua senha deve ter no mínimo 6 caracteres. Recomendamos usar letra
                            maiúscula, letra minúscula, número, símbolo e no mínimo 8 caracteres.
                        </p>
                    </div>
                    <div className="containerButton mb-4">
                        {
                            disabled ?
                                <button type="button" className={`cta ${this.props.submitting !== 'registerUser' ? 'validate' : ''}`} disabled>
                                    {this.props.submitting === 'registerUser' ? 'Aguarde ...' : 'Preencha todos os campos corretamente'}
                                </button>
                                :
                                <button type="submit" className="cta">Cadastre-se</button>
                        }
                    </div>
                </form>
                <FirebaseAuth page="signup" />
            </section>
        );
    }
}

Register.propTypes = exact({
    registerUser: PropTypes.func.isRequired,
    firebasePopupOpen: PropTypes.bool.isRequired,
    submitting: PropTypes.oneOfType([
        PropTypes.bool,
        PropTypes.string,
    ]).isRequired,
});

export default Register;
